import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { CardHeader } from '@cordata/buffet';

const BigNumberCard = ({ number, title, onClick }) => {
  const BodyElement = title ? CardBody : 'div';

  return (
    <Card body={!title} onClick={onClick}>
      {title && <CardHeader color="primary" inverse>{title}</CardHeader>}

      <BodyElement>
        <h1 className="text-secondary text-center">{number}</h1>
      </BodyElement>
    </Card>
  );
};

BigNumberCard.propTypes = {
  number: PropTypes.number,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

BigNumberCard.defaultProps = {
  number: undefined,
  title: undefined,
  onClick: () => {},
};

export default BigNumberCard;
